import clsx from "clsx";

import {
  type BenchmarkIndicatorRow,
  UniversalBenchmarksIndicator,
} from "@features/universal-benchmarks";
import { type SalesMetricV2 } from "@north-beam/nb-client-side/metrics-v2";
import { type SalesMetricRow } from "@north-beam/nb-common";
import { type CellContext } from "@tanstack/react-table";

import { getMetricComparison } from "./utils";

interface TableCellProps<TData> {
  metric: SalesMetricV2;
  cell: CellContext<TData, unknown>;
  formattedValue?: string | number;
  benchmarkKpi: BenchmarkIndicatorRow | null;
  benchmarkItemName?: string;
  showPercentChange: boolean;
}

export const CellMetricWithComparisonFormatter = <TData,>({
  cell,
  formattedValue,
  metric,
  benchmarkKpi,
  benchmarkItemName,
  showPercentChange,
}: TableCellProps<TData>) => {
  const rowData = cell.row.original as SalesMetricRow;
  const { metrics, comparisonMetrics } = rowData;

  return (
    <div
      className={clsx(
        "border-r-1 border-x-v2-tertiary text-v2-primary px-4 py-2.5 bg-inherit",
        "font-mono text-xs flex items-center justify-end h-full",
      )}
    >
      {benchmarkKpi && benchmarkKpi.target > 0 && (metrics?.spend || 0) > 0 ? (
        <div
          className={clsx("flex justify-end gap-1", {
            "flex-col items-end": showPercentChange,
            "items-center": !showPercentChange,
          })}
        >
          <UniversalBenchmarksIndicator
            variant="badge"
            benchmarkItemName={benchmarkItemName}
            benchmarkIndicatorRows={[benchmarkKpi]}
          >
            {formattedValue ?? String(cell.getValue())}
          </UniversalBenchmarksIndicator>
          {getMetricComparison(
            metric,
            metrics,
            comparisonMetrics,
            showPercentChange,
          )}
        </div>
      ) : (
        <div
          className={clsx("flex justify-end gap-1", {
            "flex-col items-end": showPercentChange,
            "items-center": !showPercentChange,
          })}
        >
          {formattedValue ?? String(cell.getValue())}
          {getMetricComparison(
            metric,
            metrics,
            comparisonMetrics,
            showPercentChange,
          )}
        </div>
      )}
    </div>
  );
};
